/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface SSOFeedbackFormArgs {
  replyTo: string;
  userEmail: string;
  disabled: boolean;
  onClose: () => unknown;
  onSubmit: (data: { criticism: string; praise: string }) => unknown;
}

export default class SSOFeedbackForm extends Component<SSOFeedbackFormArgs> {
  // Internal API
  comments = '';

  @action
  submitAction(e: Event) {
    e.preventDefault();

    this.args.onSubmit({
      criticism: 'Requesting support for new SSO protocol or identity provider',
      praise: this.comments,
    });
  }
}
